import { type FC } from 'react';
import cn from 'classnames';

import { selectCurrentInProgressLoteryData } from '@/redux/selectors/lotterySelector';
import { useAppSelector } from '@/redux/store';

import { OtherRewardItem } from './OtherRewardItem/OtherRewardItem';

interface OtherRewardsProps {
  className?: string;
}

const OtherRewards: FC<OtherRewardsProps> = ({ className }) => {
  const currentLottery = useAppSelector(selectCurrentInProgressLoteryData);
  const otherUsdtRewards = currentLottery
    ? Object.values(currentLottery.rewards).filter(
        (reward, index) => !!reward?.usdt && index > 2,
      )
    : undefined;
  const rewardSet = otherUsdtRewards
    ? new Set(otherUsdtRewards.map(({ usdt }) => usdt))
    : undefined;
  const rewardList =
    rewardSet && otherUsdtRewards
      ? [...rewardSet].map((reward) => ({
          reward,
          count: otherUsdtRewards.reduce(
            (count, rewardObj) =>
              rewardObj.usdt === reward ? count + 1 : count,
            0,
          ),
        }))
      : undefined;

  return (
    <div className={cn('w-full flex gap-[6px]', className)}>
      {rewardList?.map((props, index) => (
        <OtherRewardItem key={index} {...props} />
      ))}
    </div>
  );
};

export { OtherRewards };
